// extracted by mini-css-extract-plugin
export default {"sectionHeader":"SectionHeader_sectionHeader__AAGOE","titleBlock":"SectionHeader_titleBlock__rGEqK","title":"SectionHeader_title__a9Mwr","subtitle":"SectionHeader_subtitle__vtwnI"};